import axiosInstance from '../utils/api-util/utilApi'
import { ApiResponse } from '../models/common.model'

const config = { baseURL: process.env.REACT_APP_BACKGROUND_SERVICE_URL || '' }


export const getEmailLogsDownloadStatus = (fileId: string): Promise<ApiResponse<string>> => {
  return axiosInstance.get(`/emailLogs/getStatus/${fileId}`,config);
}

export const getEmailLogsDownloadPdf = (fileId: string): Promise<ApiResponse<any>> => {
  return axiosInstance.get(`/emailLogs/downloadPdf/${fileId}`, config)
}
 
export const getBatchProcessingsDownloadStatus = (fileId: string): Promise<ApiResponse<string>> => {
  return axiosInstance.get(`/BackgroundLog/getStatus/${fileId}`,config);
}

export const getBatchProcessingsDownloadPdf = (fileId: string): Promise<ApiResponse<any>> => {
  return axiosInstance.get(`/BackgroundLog/downloadPdf/${fileId}`, config)
} 
